<template>
  <div
    aria-label="Edit run sheet"
    role="main"
  >
    <div
      v-if="isLoading === true"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Text Centered"
      />
    </div>
    <label
      class="mr-1 h4"
      style="color:black"
      aria-live="polite"
    >Nombre de colis dans la run sheet : {{ orders.length }}
    </label>
    <b-col>
      <b-form-group
        label="Référence du colis à ajouter à la run sheet"
        label-for="input-colis-ref"
        aria-label="Champ de saisie de la référence du colis"
      >
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="MaximizeIcon" />
          </b-input-group-prepend>
          <b-form-input
            id="input-colis-ref"
            v-model="ref"
            placeholder="Scanner ou saisir la référence du colis"
            aria-label="Entrer la référence du colis à ajouter"
            @change="checkOrder"
          />
        </b-input-group>
      </b-form-group>
      <!-- table -->
      <div class="d-flex justify-content-between">
        <b-card>
          <h4 aria-live="polite">
            Colis au dépôt : {{ ordersInRepository.length }}
          </h4>
          <vue-good-table
            :columns="columns"
            :rows="ordersInRepository"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm ,
            }"
          >
            <template
              slot="table-row"
              slot-scope="props"
            >
              <!-- Column: Action -->
              <span v-if="props.column.field === 'action'">
                <span>
                  <feather-icon
                    :id="`invoice-row-${props.row.id}-show-icon`"
                    icon="CheckSquareIcon"
                    class="cursor-pointer mr-1"
                    size="16"
                    color="green"
                    @click="addItem(props.row)"
                  />
                  <b-tooltip
                    title="Ajouter"
                    class="cursor-pointer"
                    :target="`invoice-row-${props.row.id}-show-icon`"
                  />

                </span>
              </span>

              <!-- Column: BL/ID with Planification indicator -->
              <span v-else-if="props.column.field === 'id'">
                <span> {{ props.row.id }}</span><br>
                <b-badge
                  v-if="props.row.status === 18"
                  variant="info"
                  class="ml-1"
                >Rendez Vous</b-badge>
                <span v-if="props.row.status === 18 && props.row.planned_data">
                  <br><small>Prévu: {{ props.row.planned_data }}</small>
                </span>
                <!-- Last Return Reason: small with icon -->
                <div
                  v-if="props.row.last_return_reason"
                  class="text-wrap mt-1 d-flex align-items-center"
                  style="max-width: 200px; font-size: 11px; color: #888;"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                    style="color:#e74c3c;"
                  />
                  <span>
                    {{ props.row.last_return_reason.return_reason }}
                    <span class="text-muted ml-1">({{ formatDate(props.row.last_return_reason.created_at) }})</span>
                    <span
                      v-if="props.row.last_return_reason.scheduled_date"
                      class="text-info ml-1"
                    >
                      Prévu: {{ formatDate(props.row.last_return_reason.scheduled_date) }}
                    </span>
                  </span>
                </div>
              </span>

              <!-- Column: Last Return Reason -->
              <span v-else-if="props.column.field === 'last_return_reason.return_reason'">
                <!-- removed: last return reason column, now shown under BL column -->
              </span>

              <!-- Column: Common -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
            <!-- pagination -->
            <template
              slot="pagination-bottom"
              slot-scope="props"
            >
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">
                    Affichage 1 à
                  </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['50','100','500']"
                    class="mx-1"
                    @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap "> de {{ props.total }} résultats trouvés </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value)=>props.pageChanged({currentPage:value})"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-card>
        <b-card class="ml-1">
          <h4 aria-live="polite">
            Colis dans la run sheet : {{ orders.length }}
          </h4>
          <vue-good-table
            :columns="columns"
            :rows="orders"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm }"
          >
            <template
              slot="table-row"
              slot-scope="props"
            >

              <!-- Column: Action -->
              <span v-if="props.column.field === 'action'">
                <span>
                  <feather-icon
                    :id="`invoice-row-${props.row.id}-show-icon`"
                    icon="DeleteIcon"
                    color="red"
                    class="cursor-pointer mr-1"
                    size="16"
                    @click="resetItem(props.row)"
                  />
                  <b-tooltip
                    title="Annuler"
                    class="cursor-pointer"
                    :target="`invoice-row-${props.row.id}-show-icon`"
                  />

                </span>
              </span>

              <!-- Column: BL/ID with Planification indicator -->
              <span v-else-if="props.column.field === 'id'">
                <span> {{ props.row.id }}</span><br>
                <b-badge
                  v-if="props.row.status === 18"
                  variant="info"
                  class="ml-1"
                >Rendez Vous</b-badge>
                <span v-if="props.row.status === 18 && props.row.planned_data">
                  <br><small>Prévu: {{ props.row.planned_data }}</small>
                </span>
              </span>

              <!-- Column: Common -->

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template
              slot="pagination-bottom"
              slot-scope="props"
            >
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">
                    Affichage 1 à
                  </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['50','100','500']"
                    class="mx-1"
                    @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap "> de {{ props.total }} résultats trouvés </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value)=>props.pageChanged({currentPage:value})"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>

          </vue-good-table>
          <b-form-group
            label="Sélectionner le livreur"
            label-for="select-livreur"
            aria-label="Sélection du livreur pour la run sheet"
          >
            <validation-provider
              #default="{ errors }"
              name="Livreur"
            >
              <v-select
                v-model="roadmap.delivery_man"
                :clearable="false"
                placeholder="Livreur"
                label="username"
                :options="livreurs"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Sélectionner la voiture"
            label-for="select-voiture"
            aria-label="Sélection de la voiture pour la run sheet"
          >
            <div
              class="sr-only"
              aria-live="polite"
            >
              Veuillez remplir tous les champs obligatoires pour modifier la run sheet. Les champs marqués d'un astérisque sont obligatoires.
            </div>
            <validation-provider
              #default="{ errors }"
              name="Voiture"
            >
              <v-select
                v-model="selectedCar"
                :clearable="false"
                placeholder="Voiture"
                label="serial_number"
                :options="cars"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group class="d-flex justify-content-end">
            <span id="save-roadmap-btn-wrapper">
              <b-button
                ref="saveButton"
                variant="success"
                class="save-btn"
                :class="{ 'not-allowed': !isRoadmapValid }"
                aria-label="Modifier la run sheet avec les colis sélectionnés"
                :disabled="!isRoadmapValid"
                @click="updateRoadMap"
              >
                <feather-icon
                  icon="SaveIcon"
                  class="mr-1"
                  aria-hidden="true"
                />
                Modifier la run sheet
              </b-button>
              <b-tooltip
                v-if="!isRoadmapValid"
                target="save-roadmap-btn-wrapper"
                triggers="hover focus"
                placement="top"
              >
                <template v-if="!roadmap.delivery_man && selectedCar && orders.length > 0">
                  Veuillez sélectionner un livreur pour modifier la run sheet.
                </template>
                <template v-else-if="roadmap.delivery_man && !selectedCar && orders.length > 0">
                  Veuillez sélectionner un véhicule pour modifier la run sheet.
                </template>
                <template v-else-if="roadmap.delivery_man && selectedCar && orders.length === 0">
                  Veuillez ajouter au moins un colis à la run sheet.
                </template>
                <template v-else>
                  Veuillez sélectionner un livreur, un véhicule et au moins un colis.
                </template>
              </b-tooltip>
            </span>
          </b-form-group>
        </b-card>
      </div>
    </b-col>
  </div>
</template>

<script>
import {
  BCard, BButton, BPagination, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormSelect, BTooltip, BCol,

} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import { orderMatchesReference } from '@/utils/orderReference'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import storeAuth from '@/store/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import errorVoice from '@/assets/audio/error.mp3'
import ok from '@/assets/audio/ok.mp3'
import rendezVous from '@/assets/audio/rendez-vous.mp3'

export default {
  name: 'EditRoadmap',
  components: {
    BButton,
    ValidationProvider,
    VueGoodTable,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormSelect,
    BPagination,
    BTooltip,
    vSelect,
    BCard,
    BCol,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      livreurs: [],
      livreur: '',
      date: '01-10-2021',
      status: '',
      roadmap: {},
      selectedCar: null, // Selected car for the roadmap
      pageLength: 100,
      dir: false,
      errorVoice,
      columns: [
        {
          label: 'Action',
          field: 'action',
        },
        {
          label: 'Bl',
          field: 'id',
          filterOptions: {
            enabled: true,
            placeholder: 'Bl',

          },
        },
        {
          label: 'Client',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Client',
          },
        },
        {
          label: 'Gouvernorat',
          field: 'governorate',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher gouvernorat',
          },
        },
        {
          label: 'Délégation',
          field: 'delegation',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher délégation',
          },
        },
        {
          label: 'Adresse',
          field: 'address',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher adresse',
          },
        },
        {
          label: 'Tel',
          field: 'phone1',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher tel',
          },
        },
      ],
      role: '',
      orders: [],
      ordersInRepository: [],
      selected: [],
      searchTerm: '',
      ref: '',
      user: {},
      cars: [],
      car: {},
      repository: {},
      repositories: [],
      isLoading: false,
      ok,
      rendezVous,
    }
  },
  computed: {
    isRoadmapValid() {
      return (
        this.roadmap.delivery_man
        && this.roadmap.delivery_man.id
        && this.selectedCar
        && this.selectedCar.serial_number
        && this.orders.length > 0
      )
    },
  },
  watch: {
    'roadmap.delivery_man': {
      async handler(newDriver) {
        // Only auto-select driver's car if no car is currently selected
        // This maintains create page behavior when switching drivers but preserves
        // the assigned car when editing existing roadmaps
        if (newDriver && newDriver.car && !this.selectedCar) {
          this.selectedCar = newDriver.car
        }
      },
      deep: true,
    },
  },
  created() {
    this.user = storeAuth.state.user
    this.initializeData()
  },
  methods: {
    async initializeData() {
      // Load cars first, then roadmap to ensure we can match the assigned car
      await this.getCars()
      await this.getRoadmap()
    },
    async getCars() {
      this.isLoading = true
      try {
        const { data } = await axios.get('/api/cars/dropdown/')
        this.cars = data
      } catch (error) {
        this.cars = []
      }
      this.isLoading = false
    },
    checkOrder() {
      const result = this.ordersInRepository.find(element => orderMatchesReference(element, this.ref))

      if (result) {
        // Play rendez-vous audio if status is 18
        if (result.status === 18) {
          this.playAudio(this.rendezVous)
        }
        this.addItem(result)
        this.ref = ''
      } else {
        this.playAudio(this.errorVoice)
        this.ref = ''
      }
    },
    async withTitle(text) {
      await this.$swal({
        title: 'Alerte',
        icon: 'warning',
        text,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      this.ref = ''
    },
    async updateRoadMap() {
      // Prepare summary for confirmation dialog
      const summary = `Résumé de la modification :\n\n- Livreur : ${this.roadmap.delivery_man?.username || ''}\n- Véhicule : ${this.selectedCar?.serial_number || ''}\n- Nombre de colis : ${this.orders.length}`
      const confirmed = await this.$swal({
        title: 'Confirmer la modification',
        text: summary,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Oui, modifier',
        cancelButtonText: 'Annuler',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      if (!confirmed.isConfirmed) return

      this.isLoading = true
      this.orders_deleted = this.ordersInRepository.filter(item => item.status === 3)

      const obj = {
        orders: this.orders.map(item => item.id),
        orders_deleted: this.orders_deleted.map(item => item.id),
        delivery_man: this.roadmap.delivery_man.id,
        car: this.selectedCar.serial_number,
        id: this.roadmap.id,
      }
      try {
        const { data } = await axios.post('/api/roadmaps/update-roadmap/', obj)
        this.$router.push(`/roadmaps/show/${data}`)
        this.showToast('success', 'top-center', 'Run sheet modifié avec succés')
      } catch (error) {
        this.showToast('danger', 'top-center', error.toString())
      } finally {
        this.isLoading = false
      }
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    async playAudio(payload) {
      const voice = new Audio(payload)
      voice.addEventListener('canplaythrough', () => {
        voice.play()
      })
    },
    async addItem(item) {
      this.orders.push(item)
      const i = this.ordersInRepository.findIndex(element => element.id === item.id)
      this.ordersInRepository.splice(i, 1)
    },
    async resetItem(item) {
      this.ordersInRepository.push(item)
      const i = this.orders.findIndex(element => element.id === item.id)
      this.orders.splice(i, 1)
    },
    async getRoadmap() {
      this.isLoading = true
      try {
        const { data: roadmapData } = await axios.get(`/api/roadmaps/detail/${this.$route.params.id}`)
        this.roadmap = roadmapData
        // Check if roadmap is paid, redirect if so
        if (this.roadmap.is_payed) {
          this.$router.replace('/forbidden')
          return
        }

        // Only allow validated roadmap editing for admins
        if (this.roadmap.is_validated && this.user.role !== 'admin') {
          this.$router.replace('/forbidden')
          return
        }
        this.orders = this.roadmap.orders

        if (this.roadmap.car) {
          this.selectedCar = this.cars.find(car => car.serial_number === this.roadmap.car) || null
        }

        const { data: ordersInRepo } = await axios.get(`/api/orders/orders-allowed-for-roadmap/${this.roadmap.repository.id}`)
        this.ordersInRepository = ordersInRepo
        const { data: livreurs } = await axios.get('api/auth/users/drivers/', {
          params: {
            repository: this.roadmap.repository.id,
          },
        })
        this.livreurs = livreurs
      } catch (error) {
        // error handling if needed
        // If backend returns 403, global axios interceptor will handle redirect
      }
      this.isLoading = false
    },
    formatDate(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      return `${day1.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      const h = date.slice(11, 19)
      return `${year}-${month.padStart(2, '0')}-${day1.padStart(2, '0')} | ${h}`
    },
  },
}
</script>
<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-good-table.scss';

// Accessibilité : focus visible pour les champs interactifs
input:focus, select:focus, .v-select:focus {
  outline: 2px solid #005fcc !important;
  outline-offset: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}

</style>
